<template>
	<page>
		<module>
			<view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="客户类型">
							<c-select name="customer_type" :options="SALE_CUSTOMER_TYPE"></c-select>
						</m-search-item>
						<m-search-item label="客户编号">
							<c-input name="customer_code"></c-input>
						</m-search-item>
						<m-search-item label="客户全称">
							<c-input name="customer_full_name"></c-input>
						</m-search-item>
						<m-search-item label="统计日期" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<!--客户类型-->
				<template #customer_type="{data}">
					<c-state tag dict="SALE_CUSTOMER_TYPE" :value="data.customer_type"></c-state>
				</template>
				<!--期初应收-->
				<template #begin_amount="{data}">
					<span>￥{{ formatMoney(data.begin_amount) }}</span>
				</template>
				<!--本期新增-->
				<template #period_amount="{data}">
					<span>￥{{ formatMoney(data.period_amount) }}</span>
				</template>
				<!--本期收款-->
				<template #receive_amount="{data}">
					<span>￥{{ formatMoney(data.receive_amount) }}</span>
				</template>
				<!--本期售后-->
				<template #after_sale_amount="{data}">
					<span>￥{{ formatMoney(data.after_sale_amount) }}</span>
				</template>
				<!--期末结余-->
				<template #end_amount="{data}">
					<span>￥{{ formatMoney(data.end_amount) }}</span>
				</template>
				<!--预收账款-->
				<template #advance_amount="{data}">
					<span>￥{{ formatMoney(data.advance_amount) }}</span>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
import {mapState} from 'vuex'

export default {
	name: 'm_sale_receivable',

	data() {
		//统计日期格式化（yyyy-MM-dd）
		const pad = num => (num < 10 ? '0' + num : '' + num);
		const formatDate = date => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
		const now = new Date();
		const defaultStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30);   //默认最近30天

		return {
			workType: 134,
			//统计日期默认值（默认最近30天，与后端 prepareParams 兜底口径一致）
			defaultSearchData: {
				start_date: `${formatDate(defaultStartDate)} 00:00:00`,
				end_date: `${formatDate(now)} 23:59:59`
			}
		}
	},

	computed: {
		...mapState(['saasInfo', 'SALE_CUSTOMER_TYPE'])
	},

	methods: {
		/**
		 * 金额格式化（保留两位小数）
		 */
		formatMoney(value) {
			if (value === undefined || value === null || value === '') {
				return '0.00';
			}
			var num = Number(value);
			if (isNaN(num)) {
				return '0.00';
			}
			return num.toLocaleString('zh-CN', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
		}
	}
}
</script>
